(function () {
  'use strict';

  var CONFIG = {
    productGridSelector: '.collection-grid',
    productCardSelector: '.product-item',
    productLinkSelector: 'a[href*="/products/"]',
    searchParamName: 'q',
    pinnedClass: 'search-pin-pinned',
    showPinnedBadge: false,
    pinnedBadgeText: 'Featured',
    pinnedBadgeClass: 'search-pin-badge',
    rulesElementId: 'search-pin-rules'
  };

  function normalizeQuery(q) {
    return (q || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function extractHandle(href) {
    var match = (href || '').match(/\/products\/([^?#/]+)/);
    return match ? match[1].toLowerCase() : null;
  }

  function createBadge() {
    var badge = document.createElement('span');
    badge.className = CONFIG.pinnedBadgeClass;
    badge.textContent = CONFIG.pinnedBadgeText;
    badge.setAttribute('aria-label', 'Featured product');
    return badge;
  }

  function applyPinning() {
    if (window.__searchPinApplied) return;

    var params = new URLSearchParams(window.location.search);
    var rawQuery = params.get(CONFIG.searchParamName);
    var page = parseInt(params.get('page') || '1', 10);
    if (!rawQuery || page > 1) return;

    var query = normalizeQuery(rawQuery);
    if (!query) return;

    var rulesEl = document.getElementById(CONFIG.rulesElementId);
    if (!rulesEl) return;

    var rulesData;
    try {
      rulesData = JSON.parse(rulesEl.textContent);
    } catch (e) {
      console.warn('[SearchPin] Failed to parse pin rules JSON:', e);
      return;
    }
    if (!rulesData || !Array.isArray(rulesData.rules)) return;

    var matchedRule = null;
    for (var i = 0; i < rulesData.rules.length; i++) {
      var rule = rulesData.rules[i];
      if (!Array.isArray(rule.queries) || !Array.isArray(rule.products)) continue;
      for (var j = 0; j < rule.queries.length; j++) {
        if (normalizeQuery(rule.queries[j]) === query) {
          matchedRule = rule;
          break;
        }
      }
      if (matchedRule) break;
    }
    if (!matchedRule || matchedRule.products.length === 0) return;

    var grid = document.querySelector(CONFIG.productGridSelector);
    if (!grid) {
      console.warn('[SearchPin] Product grid not found:', CONFIG.productGridSelector);
      return;
    }

    var cards = Array.from(grid.querySelectorAll(CONFIG.productCardSelector));
    if (cards.length === 0) {
      return;
    }

    var cardsByHandle = {};
    cards.forEach(function (card) {
      var link = card.querySelector(CONFIG.productLinkSelector);
      if (link) {
        var handle = extractHandle(link.getAttribute('href'));
        if (handle) cardsByHandle[handle] = card;
      }
    });

    var pinnedCards = [];
    var pinnedHandles = {};
    matchedRule.products.forEach(function (handle) {
      var h = handle.toLowerCase();
      if (cardsByHandle[h]) {
        pinnedCards.push(cardsByHandle[h]);
        pinnedHandles[h] = true;
      }
    });
    if (pinnedCards.length === 0) return;

    var remainingCards = cards.filter(function (card) {
      var link = card.querySelector(CONFIG.productLinkSelector);
      if (!link) return true;
      var handle = extractHandle(link.getAttribute('href'));
      return handle ? !pinnedHandles[handle] : true;
    });

    var allOrdered = pinnedCards.concat(remainingCards);
    allOrdered.forEach(function (card, index) {
      card.style.order = index + 1;
    });

    if (CONFIG.pinnedClass) {
      pinnedCards.forEach(function (card) {
        card.classList.add(CONFIG.pinnedClass);
      });
    }
    if (CONFIG.showPinnedBadge) {
      pinnedCards.forEach(function (card) {
        if (!card.querySelector('.' + CONFIG.pinnedBadgeClass)) {
          card.style.position = card.style.position || 'relative';
          card.insertBefore(createBadge(), card.firstChild);
        }
      });
    }

    window.__searchPinApplied = true;
  }

  window.SearchPin = window.SearchPin || {};
  window.SearchPin.apply = applyPinning;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPinning);
  } else {
    applyPinning();
  }
})();
